import { z } from "zod";
export const SecurityReplacements = z.record(z.string()).nullable();
export const SecuritiesRemoved = z.string().array().nullable();
export const cacheTimeMs = 6 * 60 * 60 * 1000; // 6 hours
export const staleTimeMs = 6 * 60 * 60 * 1000; // 6 hours
export const dateFormat = "yyyy-MM-dd";
//# sourceMappingURL=Shared.js.map